

















































































import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../store/index';

export default Vue.extend({
  name: 'Explain',
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo,
    checkText: (state: any) => store.getters.getCheckText,
    productId: (state: any) => store.getters.getProductId,
  }),
  data() {
    return {
    };
  },
  methods: {
    // 初始化报告指标说明
    initExplain() {
      // console.log('报告指标说明');
    }
  },
  mounted() {
    this.initExplain();
  }
});
